import * as i18next from "i18next";
import { UserErrorCode } from "../client/generated";

export function translateUserError(userErrorCode: UserErrorCode): string {
  return i18next.t(`userErrors.${userErrorCode}`, {
    defaultValue: i18next.t("userErrors.UNKNOWN_ERROR"),
  });
}
